"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var formjs_1 = require("@smartsheet-dataflow/formjs");
exports.setExpressionAction = (_a = formjs_1.createInputFeature('expression'), _a.actionCreator), exports.expressionSelector = _a.selectorCreator, exports.ExpressionFeature = _a.featureReducer;
//# sourceMappingURL=expression.js.map